import React, { useState } from "react";
import "./OwViewOptionsPanel.scss";
import ControlTypeEnum from "../../../models/ControlTypeEnum";
import IViewOptions from "../../../models/IViewOptions";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import OwTranslate from "../OwTranslate/OwTranslate";
import * as _ from "lodash-es";
import OwButton from "../OwButton/OwButton";

type Props = {
    viewOptions: IViewOptions[];
    onChangeFn: (e: any) => void;
    showSaveBtn?: boolean;
    saveFn?: () => void;
};

export const OwViewOptionsPanel = (props: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const togglePanel = () => {
        setIsOpen(!isOpen);
    };

    let chevronIcon = <i className={"fas fa-chevron-square-up "}></i>;
    let buttonTitle = <OwTranslate defaultMessage={"show options"} id={"show_options"} />;

    if (isOpen) {
        chevronIcon = <i className={"fas fa-chevron-square-down "}></i>;
        buttonTitle = <OwTranslate defaultMessage={"hide options"} id={"hide_options"} />;
    }

    const optionsList = props.viewOptions.map((viewOption) => {
        let listItem: any;

        switch (viewOption.type) {
            case ControlTypeEnum.checkbox:
                listItem = (
                    <div key={viewOption.prop}>
                        <OwCheckbox checked={viewOption.value} fn={props.onChangeFn} label={viewOption.title} name={viewOption.prop} />
                    </div>
                );
                break;
        }

        return listItem;
    });

    const optionsLen = optionsList.length;

    const headerHeight = 2;
    let bottom = -2 * optionsLen + "rem";
    const height = 2 * optionsLen + "rem";

    if (isOpen) {
        bottom = "0rem";
    }

    return (
        <div className={"OwViewOptionsPanel d-print-none " + (isOpen ? "optionsPanelOpen" : "")} style={{ bottom }}>
            <div className={"showLabel pointer"} onClick={togglePanel}>
                {chevronIcon} {buttonTitle}
            </div>
            <div className={"mainSection"} style={{ height }}>
                {props.showSaveBtn ? (
                    <div className={"text-end"}>
                        <OwButton title={"save"} fn={props.saveFn} />
                    </div>
                ) : null}
                <div className={"col"}>{optionsList}</div>
            </div>
        </div>
    );
};
